import { type DocumentNode, gql } from '@apollo/client';

/**
 * Query variables for fetching markers by asset ID
 */
export interface AssetMarkersVariables {
  asset_Id?: string;
}

/**
 * Author user structure
 */
export interface MarkerAuthorUser {
  id: string;
}

/**
 * Author structure
 */
export interface MarkerAuthor {
  id: string;
  user: MarkerAuthorUser;
}

/**
 * Asset structure within marker
 */
export interface MarkerAsset {
  id: string;
  name: string;
  duration: number | null;
  timecode: string | null;
}

/**
 * Marker node structure
 */
export interface MarkerNode {
  __typename: string;
  id: string;
  author: MarkerAuthor;
  asset: MarkerAsset;
  title: string | null;
  description: string | null;
  markIn: string;
  markOut: string | null;
  createdAt: string;
  lastModified: string;
}

/**
 * Marker edge structure
 */
export interface MarkerEdge {
  __typename: string;
  node: MarkerNode;
}

/**
 * Page info structure
 */
export interface PageInfo {
  startCursor: string | null;
  endCursor: string | null;
}

/**
 * All markers connection structure
 */
export interface AllMarkersConnection {
  pageInfo: PageInfo;
  edges: MarkerEdge[];
  totalCount: number;
}

/**
 * Response structure for assetMarkers query
 */
export interface AssetMarkersResponse {
  allMarkers: AllMarkersConnection;
}

const assetMarkers: DocumentNode = gql`
  query Markers($asset_Id: ID) {
    allMarkers(asset_Id: $asset_Id) {
      pageInfo {
        startCursor
        endCursor
      }
      edges {
        __typename
        node {
          id
          author {
            id
            user {
              id
            }
          }
          asset {
            id
            name
            duration
            timecode
          }
          title
          description
          markIn
          markOut
          createdAt
          lastModified
        }
      }
      totalCount
    }
  }
`;

export default assetMarkers;
